import { submitUser } from "./forms/user";
import { submitPayment } from "./forms/payment";
import { submitUserAndPayment } from "./forms/oneForm";
import { handleUrlStatus } from "./utils/url";
import { importFacebookTracker } from "./trackers/facebook";
import {
    createMonthOptions,
    createStateOptions,
    createYearOptions,
    deleteStateSelectIfOptionsNotExists
} from "./utils/options";
import { initLoader } from "./utils/loader";
import { retryingPayment } from "./utils/retryingPayment";
import { initInputOptions} from "./utils/formInputs";
import { checkEmailSpell, initValidation } from "./forms/validations";
import { checkIfAllUserDataIsFilledAndGoToPaymentStep, fillPlaceholders } from "./utils/autoFill";

export const userForm = document.querySelector('#userForm');
userForm?.addEventListener('submit', submitUser);

const cardForm = document.querySelector('#cardForm');
cardForm?.addEventListener('submit', submitPayment);

const fullDataForm = document.querySelector('#fullDataForm');
fullDataForm?.addEventListener('submit', submitUserAndPayment);

const retryPaymentButton = document.getElementById('retryPaymentButton');
retryPaymentButton?.addEventListener('click', retryingPayment);

export const isFullDataForm = !!fullDataForm;

export const getPageCountry = document.getElementById('countryIso2')?.value;

const init = () => {
    importFacebookTracker();
    handleUrlStatus();
    createMonthOptions();
    createYearOptions();
    createStateOptions(getPageCountry);
    deleteStateSelectIfOptionsNotExists();
    initLoader();
    initInputOptions();
    initValidation();
    checkEmailSpell();
    checkIfAllUserDataIsFilledAndGoToPaymentStep();
}

init();

if (document.readyState === 'ready' || document.readyState === 'complete') {
    fillPlaceholders();
} else {
    document.onreadystatechange = function () {
        if (document.readyState === "complete") {
            fillPlaceholders();
        }
    }
}

